import { Box, Container, Typography } from "@material-ui/core";
import { MyFooter } from "../footer/MyFooter";
import { MyAppBar } from "../appbar/MyAppBar";
import { useTranslation } from "react-i18next";

export function RegisterEmailCompleted(props: {
}): JSX.Element {
  const { t } = useTranslation();
  return (
    <Container
      maxWidth={false}
      disableGutters={true}
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <MyAppBar />
      <Box position="relative" flexGrow="1">
        {/* 冒頭メッセージ begin */}
        <Box mt={4} mx={3}>
          <Typography variant="h5" align="left">
            <Box fontWeight="fontWeightBold">
              {`${t("email.thank_you_for_registering")} ${t(
                "email.winners_will_be_selected_by_a_strict_lottery_and_will_be_notified_by_mail"
              )}`}
              {/* ご登録いただいたメールアドレス宛にクーポンのURLをお送りさせて頂きました。受信メールをご確認ください。 */}
            </Box>
          </Typography>
        </Box>
        {/* 冒頭メッセージ end */}
      </Box>
      <MyFooter />
    </Container>
  );
}
